import Buttons from '../../../../../components/ui/button/Buttons'

const ButtonforValidate = ({ clickEvent,isDisable}) => {
  return (
    <div>
      {/* <Buttons
        buttonText="Validate"
        buttonTypeClassName="btn success-btn ml-auto"
        isDisable={isDisable}
        onClick={clickEvent}
      /> */}
    </div>
  )
}

export default ButtonforValidate
